import type {
  GraphQL,
  TransportAvailabilityCriteria,
} from '@libs/trip-planner-interfaces';
import { normalizeDateOnlyString } from '@libs/utils';

import { getRecipeQL } from './recipeQL';

export function getTransportListRequestQL(
  criteria: TransportAvailabilityCriteria
): GraphQL.TransportListRequestQL {
  return {
    recipe: getRecipeQL({
      userCriteria: criteria.userCriteria.recipe,
      businessCriteria: criteria.businessCriteria,
    }),
    ingredientIndex: criteria.userCriteria.ingredientIndex,
    dayOnly: normalizeDateOnlyString(criteria.userCriteria.day),
    elementsInPage: criteria.userCriteria.elementsInPage,
    page: criteria.userCriteria.page,
  };
}
